import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { faPlus, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// REDUX
import { useSelector } from "react-redux";
// CUSTOM HOOKS
import useGetAllOrganizationsLight from "../../../customHooks/GET_requests/useGetAllOrganizationsLight";
// INTERFACES
import { FormularyRowSelectOrganizationInterface } from "../../../interfaces/FormularyRow";
import { RootState } from "../../../app/store";
import { isMasterAdmin } from "../../../utils/isMasterAdmin";

export default function FormularyRowSelectOrganization({
  record,
  text,
  value,
  inputIcon,
  formAction,
  variableName,
  itemId,
  textLink,
  onChangeFormValue,
}: FormularyRowSelectOrganizationInterface) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Option } = Select;
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { globalOrganizationId, userLogged } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const { organizationsLight: organizations, isLoadingGetAllOrganizationsLight } =
    useGetAllOrganizationsLight();

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const getItemName = (recordId: string) => {
    const item = organizations.find((v: any) => v.id === recordId);
    return item ? item.name : "--";
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <>
      {record.id === "" ? (
        <Select
          optionFilterProp="children"
          showSearch
          allowClear={false}
          size="small"
          value={formAction === "create" ? value : null}
          disabled={
            formAction === "edit" ||
            organizations.length === 0 ||
            !isMasterAdmin(userLogged, globalOrganizationId)
          }
          className="generalStyles__width200px"
          placeholder={t("general.organization")}
          onChange={(e: string) => {
            onChangeFormValue(e, variableName);
          }}
          loading={isLoadingGetAllOrganizationsLight}
          suffixIcon={
            inputIcon ? <FontAwesomeIcon icon={faPlus} className="generalStyles__info" /> : null
          }
        >
          {organizations.map((item: any) => (
            <Option key={item.id} value={item.id}>
              {item.name}
            </Option>
          ))}
        </Select>
      ) : (
        <>
          {formAction === "edit" && record.id === itemId ? (
            <Select
              optionFilterProp="children"
              allowClear={false}
              size="small"
              value={value}
              className="generalStyles__width200px"
              placeholder={t("general.organization")}
              onChange={(e: string) => {
                onChangeFormValue(e, variableName);
              }}
              loading={isLoadingGetAllOrganizationsLight}
              disabled={false}
              suffixIcon={
                inputIcon ? <FontAwesomeIcon icon={faPen} className="generalStyles__info" /> : null
              }
            >
              {organizations.map((item: any) => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          ) : (
            <div className={textLink ? "generalStyles__info" : ""}>{getItemName(text)}</div>
          )}
        </>
      )}
    </>
  );
}
